module.exports = __webpack_public_path__ + "a9ffa25ce2f8b0646be42cdf32621397.pdf";